export default __webpack_public_path__ + "static/instagram-e719d8b29f452a16302dde353806c1fa.png";